import { createFileRoute } from "@tanstack/react-router";
import { Mlp20CampaignV2Page } from "@/components/campaign/Mlp20CampaignV2Page";

const TITLE = "Meet MLP 2.0: Media Intelligence Demo | Perceptica";
const DESCRIPTION = "See how Perceptica MLP 2.0 connects changes in media coverage with publications, topics, reporting and expert analysis.";

export const Route = createFileRoute("/mlp-2-0")({
  head: () => ({
    meta: [
      { title: TITLE }, { name: "description", content: DESCRIPTION }, { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: TITLE }, { property: "og:description", content: DESCRIPTION }, { property: "og:type", content: "website" },
      { property: "og:url", content: "https://perceptica.com/mlp-2-0" }, { property: "og:image", content: "https://perceptica.com/og/mlp-2-0.jpg" },
      { property: "og:image:width", content: "1200" }, { property: "og:image:height", content: "630" }, { property: "og:image:alt", content: "Perceptica MLP 2.0 media listening platform" },
      { name: "twitter:card", content: "summary_large_image" }, { name: "twitter:title", content: TITLE }, { name: "twitter:description", content: DESCRIPTION }, { name: "twitter:image", content: "https://perceptica.com/og/mlp-2-0.jpg" },
    ],
  }),
  component: () => <Mlp20CampaignV2Page locale="en" />,
});
